import {fork, put, takeEvery, all} from 'redux-saga/effects';
import config from '../../../config/config';
import {
    LogControllerDtoItemShopPurchaseLogListRequest, LogControllerDtoItemShopPurchaseLogListResponse,
    PerplayLogApi,
} from '../../models/src';

import {getErrorMessage} from '../../../utils/serverErrorCheck';
import {ITEM_SHOP_LOG_LIST_REQUEST} from "../../constants/log/itemShopLogConstants";


const api = new PerplayLogApi(config.API_CLIENT);

function* itemShopLogListRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoItemShopPurchaseLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = payload.accountNo || 0;

        const result = yield api.apiPerplayLogItemShopPurchaseLogListPost({logControllerDtoItemShopPurchaseLogListRequest: requestData}, () => {
        });
        const data = api.apiClient.deserialize(result, LogControllerDtoItemShopPurchaseLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* itemShopLogRootSaga() {
    yield all([
        takeEvery(ITEM_SHOP_LOG_LIST_REQUEST, itemShopLogListRequestSaga),
    ]);
}

const itemShopLogSagas = [fork(itemShopLogRootSaga)];

export default itemShopLogSagas;
